import { ROLES } from "../../../types/user";
import Form from "../../../components/Forms/UserForm";
import { PermissionControl } from "../../../components/Permission";
import { permissions } from "../../../utils/permissions";
import { getRole } from "../../../services/api/utils.api";
import { useAppThunkDispatch } from "../../../store/hooks";
import { getActiveUser } from "../../../store/actions/userActions";

const CreateNewUserPage = () => {
  const dispatch = useAppThunkDispatch();

  dispatch(getActiveUser(null));

  return (
    <PermissionControl
      permissionPath={permissions.pages.players.create}
      role={getRole()}
    >
      <Form role={ROLES.STUDENT} />
    </PermissionControl>
  );
};

export default CreateNewUserPage;
